<mat-expansion-panel>
    <mat-expansion-panel-header>
        <mat-panel-title>{{ panelTitle }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="registry-recap-container" *ngIf="showForms">
        <div class="registry-recap-box">
            <ng-container>
                <dov class='mt-3 p-2'>
                    <app-basic-card>
                        <h6 class="card-header-label" style="padding: 1em;">Dati anagrafici</h6>
                        <app-basic-form [form]="registryForm" [keys]="registryFormKeys"></app-basic-form>
                    </app-basic-card>
                </dov>
                <div class='mt-3'>
                    <app-residence-change-isv
                      [form]="residenceForm"
                      [countriesList]="countriesList"
                      [provincesList]="provincesList"
                      [placesList]="placesList"
                      [title]="isLegalSubject ? 'Sede legale' : 'Residenza'"
                    ></app-residence-change-isv>
                </div>
                <div class='mt-3' *ngIf="!isEffectiveOwner">
                    <app-residence-change-isv
                        [form]="addressForm"
                        [additionalForm]="residenceForm"
                        [countriesList]="countriesList"
                        [provincesList]="provincesList"
                        [placesList]="placesList"
                        [title]="'Recapito'"
                        [isAddressForGianos]="true"
                    ></app-residence-change-isv>
                </div>
                <div class='mt-3' *ngIf="!isLegalSubject">
                    <app-basic-card>
                        <h6 class="card-header-label" style="padding: 1em;">Documento di riconoscimento</h6>
                        <app-basic-form [form]="identificationDocumentForm" [keys]="identificationDocumentFormKeys"></app-basic-form>
                    </app-basic-card>
                </div>
                <div class='mt-3 mb-2' *ngIf="!isEffectiveOwner && businessForm">
                    <app-basic-card>
                        <h6 class="card-header-label" style="padding: 1em;">Informazioni sull'attività economica</h6>
                        <app-basic-form [form]="businessForm" [keys]="businessFormKeys"></app-basic-form>
                    </app-basic-card>
                </div>
                <div *ngIf="isContractorChange">
                    <div class='mt-3 mb-2' *ngIf="!isLegalSubject">
                        <app-basic-card>
                        <h6 class="card-header-label" style="padding: 1em;">Adeguata verifica</h6>
                        <app-basic-form [form]="properVerificationForm" [keys]="properVerificationFormKeys"></app-basic-form>
                    </app-basic-card>
                    </div>
                    <div class='mt-3 mb-2' *ngIf="!isEffectiveOwner && consentForm">
                        <app-basic-card>
                            <h6 class="card-header-label" style="padding: 1em;">Consensi</h6>
                            <app-basic-form [form]="consentForm" [keys]="constentsFormKeys"></app-basic-form>
                        </app-basic-card>
                    </div>
                </div>
            </ng-container>
        </div>
        <ng-container *ngIf="buttonsList && !isReadOnly">
            <div class="col-2 d-flex justify-content-between mt-3">
                <ng-container *ngFor="let button of buttonsList">
                    <ng-container *ngIf="button.isRaised; else defaultButtonTemplate">
                        <button
                            mat-raised-button
                            [color]="button?.style" 
                            (click)="onActionRequested(button)"
                        >{{ button?.label }}</button>
                    </ng-container>
                    <ng-template #defaultButtonTemplate>
                        <button
                            mat-button
                            [color]="button?.style" 
                            (click)="onActionRequested(button)"
                        >{{ button?.label }}</button>
                    </ng-template>
                </ng-container>
            </div>
        </ng-container>
    </div>
</mat-expansion-panel>
